import { render } from "./DefaultAction.vue?vue&type=template&id=55022714"
import script from "./DefaultAction.vue?vue&type=script&lang=js"
export * from "./DefaultAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__